import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/attributes/class/class.js";
import "dabbyjs/src/attributes/data/data.js";
import "dabbyjs/src/attributes/attr/attr.js";
import "dabbyjs/src/attributes/val/val.js";
import "dabbyjs/src/dimensions/position/position.js";
import "dabbyjs/src/events/on/on.js";
import "dabbyjs/src/manipulation/insert/insert.js";
import "dabbyjs/src/traversal/closest/closest.js";
import "dabbyjs/src/traversal/next-prev/next-prev.js";
import "dabbyjs/src/traversal/parents/parents.js";
import "dabbyjs/src/attributes/prop/prop.js";
import "dabbyjs/src/core/each/each.js";
import "dabbyjs/src/events/trigger/trigger.js";
import {getfiles} from "./table.js";
import error from "./error.js";
import copy from "../../../swgfl/javascript/copy.js";

function formValid(obj, cls) {
	let valid = true,
		errorclass = "hashform__control--error";
	$("input,textarea,select", obj).each(function () {
		const input = $(this),
			box = input.attr("type") === "checkbox" ? input.parent() : input;
		if (!this.reportValidity()) {
			box.addClass(errorclass);

			// reset back to the current page, as the event is not cancellable
			const parent = input.closest("." + cls);
			parent.prev().prop("checked", true);

			// add error message
			if (valid) {
				const msg = input.data("error");
				if (msg) {
					error(parent, msg);
				}
			}
			valid = false;
		} else {
			box.removeClass(errorclass);
		}
	});
	return valid;
}

export default (obj, config) => {

	// the new system
	obj.on("submit", function (e) {
		let $this = $(this),
			submit = $(e.submitter),
			files = getfiles(),
			loader = "download__loader",
			cls = "hashform__item";

		// check there are some files
		if (files.length === 0) {
			$("#hashform-images").prop("checked", true).trigger("change");

		// check the form has been completed
		} else if (formValid($this, cls)) {

			// prepare payload
			const payload = new FormData(this),
				parent = submit.closest("." + cls),
				loadcls = cls + "--loading";

			// add hashes to payload
			payload.append("hashes", JSON.stringify(files.map(item => ({
				name: item.name,
				md5: item.md5 || null,
				pdq: item.pdq || null,
				pdna: item.pdna || null,
				url: item.url || null,
				tags: item.tags
			}))));

			// add submit button
			if (e.submitter) {
				payload.append(e.submitter.name, e.submitter.value);
			}

			// show a loader
			$this.addClass(loader);
			parent.addClass(loadcls);
			
			// submit the case
			fetch($this.attr("action") || location.href, {
				method: "POST",
				headers: {
					Accept: "application/json"
				},
				body: payload
			})
				.then(response => {
					if (response.status >= 500) {
						throw new Error();
					}
					return response.json();
				})
				.then(json => {
					if (json.error) {
						error(parent, json.msg);
					} else {
						const complete = $("#hashform-complete + .hashform__item");
						complete.append(json.html);
						copy($(".hashform__casenumber-copy", complete)); // enables the case number to be copied
						$("#hashform-complete").prop("checked", true).trigger("change");
					}
				})
				.catch(() => {
					error(parent, config.error);
				})
				.finally(() => {
					$this.removeClass(loader);
					parent.removeClass(loadcls);
				});
		}
		e.preventDefault();
	});
}